<template>
  <b-container class="px-0">
    <b-row class="justify-content-md-center">
      <b-col cols=12>
        <b-card no-body 
        tag="h1"
        class="border-0 pt-3 pb-3 bg-transparent"
        >{{pageTitle}}
        </b-card>
      </b-col>
    </b-row>
    <b-row id="catalogopac" class="justify-md-content-center text-center">
      <b-col cols=12>
        <b-form>
          <b-input id="search_form" placeholder="Scrie aici expresia căutată..." v-model="search"></b-input> 
          <b-button variant="primary" class="my-4 px-4" @click="cauta">Caută</b-button>
        </b-form>
        <iframe id="iframeopac" :src="src"></iframe>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      pageTitle: 'Caută în catalogul bibliotecii',
      search: '',
      src : 'https://catalog.bibliotecaarad.ro/opac/mobile/home'
   
    };
  },
  methods: {
    cauta() {
      this.src = 'https://catalog.bibliotecaarad.ro/opac/mobile/home#/opac/mobile/search?q=' + this.search;
    } 
  }
};
</script>

<style lang="scss" scoped>
#iframeopac {
  width: 100%;
  min-height: 740px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  border: none;
}
</style>
